/* Mobile menu: opens under the header, thin burger turns into an X,
   first screen lists top-level items, tapping one slides in its submenu. */
(() => {
  const MQ = window.matchMedia('(max-width: 989px)');

  if (!customElements.get('cbm-mobile-menu')) {
    class CbmMobileMenu extends HTMLElement {
      connectedCallback() {
        this.header = this.closest('header-component') || this.closest('header');
        this.list = this.querySelector('.cbm-m__list');
        this.screens = this.querySelector('.cbm-m__screens');
        this.isOpen = false;
        this.inert = true;

        this.addEventListener('click', (e) => {
          const opener = e.target.closest('[data-sub]');
          if (opener) {
            e.preventDefault();
            this.showSub(opener.getAttribute('data-sub'));
            return;
          }
          if (e.target.closest('.cbm-m-back')) {
            e.preventDefault();
            this.back();
            return;
          }
          if (e.target.closest('a[href]')) this.close();
        });

        this.onKey = (e) => {
          if (e.key !== 'Escape' || !this.isOpen) return;
          if (this.classList.contains('has-sub')) this.back();
          else this.close();
        };
        this.onResize = () => {
          if (!MQ.matches) this.close();
          else if (this.isOpen) this.setHeight();
        };
        document.addEventListener('keydown', this.onKey);
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('resize', this.onResize);
        document.documentElement.classList.remove('cbm-m-lock');
      }

      /* Build the rows and sub screens from the Mega menu item blocks. */
      build() {
        this.list.innerHTML = '';
        this.screens.innerHTML = '';
        const sources = document.querySelectorAll('template.cbm-m-src');
        let i = 0;
        sources.forEach((tpl) => {
          const frag = tpl.content.cloneNode(true);
          const row = frag.querySelector('.cbm-m-row');
          const sub = frag.querySelector('.cbm-m-sub');
          if (!row) return;
          if (sub) {
            const id = 'cbm-m-sub-' + i;
            sub.id = id;
            const trigger = row.querySelector('[data-sub]');
            if (trigger) trigger.setAttribute('data-sub', id);
            this.screens.appendChild(sub);
          }
          const li = document.createElement('li');
          li.style.setProperty('--i', i);
          li.appendChild(row);
          this.list.appendChild(li);
          i += 1;
        });
        this.querySelectorAll('.cbm-m__extras > li').forEach((li, n) => li.style.setProperty('--i', i + n));
      }

      setHeight() {
        const rect = this.header ? this.header.getBoundingClientRect() : { bottom: 0 };
        const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        this.style.setProperty('--cbm-m-h', Math.max(vh - Math.max(rect.bottom, 0), 200) + 'px');
      }

      open() {
        if (this.isOpen || !MQ.matches) return;
        this.build();
        this.setHeight();
        this.isOpen = true;
        this.inert = false;
        this.setAttribute('aria-hidden', 'false');
        this.classList.remove('has-sub');
        document.documentElement.classList.add('cbm-m-lock');
        requestAnimationFrame(() => this.classList.add('is-open'));
        this.syncButton();
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('cbm-m-lock');
        this.syncButton();
        setTimeout(() => {
          if (this.isOpen) return;
          this.inert = true;
          this.classList.remove('has-sub');
          this.querySelectorAll('.cbm-m-sub.is-active').forEach((s) => s.classList.remove('is-active'));
        }, 520);
      }

      toggle() {
        this.isOpen ? this.close() : this.open();
      }

      showSub(id) {
        const target = this.querySelector('#' + CSS.escape(id));
        if (!target) return;
        this.querySelectorAll('.cbm-m-sub.is-active').forEach((s) => s.classList.remove('is-active'));
        target.classList.add('is-active');
        this.classList.add('has-sub');
        target.scrollTop = 0;
        const back = target.querySelector('.cbm-m-back');
        if (back) setTimeout(() => back.focus({ preventScroll: true }), 300);
      }

      back() {
        this.querySelectorAll('.cbm-m-sub.is-active').forEach((s) => s.classList.remove('is-active'));
        this.classList.remove('has-sub');
      }

      syncButton() {
        document.querySelectorAll('.cbm-burger').forEach((b) => {
          b.classList.toggle('is-open', this.isOpen);
          b.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
          b.setAttribute('aria-label', this.isOpen ? 'Close menu' : 'Menu');
        });
      }
    }

    customElements.define('cbm-mobile-menu', CbmMobileMenu);
  }

  // One delegated listener for the burger (survives editor re-renders).
  if (!window.__cbmBurgerBound) {
    window.__cbmBurgerBound = true;
    document.addEventListener('click', (e) => {
      const burger = e.target.closest('.cbm-burger');
      if (!burger) return;
      const panel = document.querySelector('cbm-mobile-menu');
      if (panel) panel.toggle();
    });
  }
})();